<template>
    <div class="sitio-noencontrado-fondo cuatrocientoscuatro">
        <h2 >
            La pagina que estabas buscando no fue encontrada,<br> ¡Intenta buscar otra vez!
        </h2>
    </div>
</template>

<script>
export default {
    data(){
        return{
             isActive: true
        }
    }
}
</script>


<style scoped>
.bg-trasparent{
    background-color: #231f20!important;
}
</style>




// WEBPACK FOOTER //
// src/components/NoEncontrada.vue